/**
 * RudderTyper.ts
 * This file was automatically generated by Rudder CLI 0.25.1.
 * Do not modify manually.
 */

import type {
    ApiOptions,
    RudderAnalytics,
    ApiCallback,
    ApiObject as SDKApiObject,
    IdentifyTraits as SDKIdentifyTraits,
} from "@rudderstack/analytics-js";

// ===== Property Enums =====

export type PropertyAbandonmentReason = "closed_drawer" | "navigated_away" | "session_timeout" | "payment_declined";

export type PropertyAction = "created" | "updated";

export type PropertyActivationStatus = "no_source" | "source_only" | "connection_created" | "data_flowing" | "checklist_complete";

export type PropertyAudienceType = "data_graph" | "cohort" | "legacy";

export type PropertyAuthMethod = "email_password" | "google" | "sso";

export type PropertyBlockingMode = "block" | "sample" | "allow";

export type PropertyChangeType = "upgrade" | "downgrade" | "trial_started" | "trial_converted" | "trial_expired" | "cancellation";

export type PropertyChannelType = "email" | "slack" | "webhook";

export type PropertyCompletionStatus = "completed" | "skipped" | "partial";

export type PropertyConditionOperator = "equal" | "notEqual" | "in";

export type PropertyConnectionMode = "cloud_mode" | "device_mode" | "hybrid";

export type PropertyCreationFlow = "ide" | "copilot" | "git";

export type PropertyCtaLocation = "sidebar_badge" | "event_usage_alert" | "resource_limit_banner" | "feature_gate" | "plans_page_cta" | "workspace_overlay" | "trial_expiry_banner" | "checklist_header_slot" | "migration_wizard";

export type PropertyCurrency = "usd";

export type PropertyDataOrigin = "sql_model" | "audience" | "direct_table";

export type PropertyDestinationCategory = "warehouse" | "cloud";

export type PropertyDestinationMode = "cloud_mode" | "device_mode";

export type PropertyDestinationPage = "plans_page" | "subscription_drawer" | "contact_sales_modal" | "trial_start" | "admin_notification";

export type PropertyErrorType = "payment_declined" | "3ds_failed" | "network_error" | "validation_error" | "stripe_error";

export type PropertyEventType = "track" | "identify" | "page" | "screen" | "group";

export type PropertyFeatureName = "profiles" | "audiences" | "data_graph" | "data_catalog" | "bot_detection" | "event_blocking" | "service_access_tokens" | "scim" | "data_residency";

export type PropertyGitProvider = "github" | "gitlab" | "bitbucket";

export type PropertyIntegrationType = "source" | "destination";

export type PropertyLanguage = "javascript" | "python";

export type PropertyLimitType = "event_volume" | "cloud_extract_sources" | "warehouse_actions" | "transformations" | "tracking_plans" | "event_blocking" | "team_members" | "workspaces" | "retl_connections";

export type PropertyModelType = "entity" | "event";

export type PropertyOnboardingQuestionsStatus = "completed" | "skipped" | "pending";

export type PropertyOutcome = "downgraded_to_free" | "converted_during_grace";

export type PropertyPageCategory = "collect" | "unify" | "activate" | "govern" | "monitor" | "settings" | "onboarding" | "auth" | "home" | "directory" | "unknown";

export type PropertyPaymentMethodType = "credit_card" | "debit_card" | "bank_transfer";

export type PropertyPropertyType = "string" | "integer" | "boolean" | "array" | "object";

export type PropertyRelationshipType = "one-to-one" | "one-to-many" | "many-to-one";

export type PropertyRequiredPlan = "growth" | "enterprise";

export type PropertyResourceCategory = "event_stream" | "reverse_etl" | "tracking_plan" | "profiles";

export type PropertyResourceStatus = "healthy" | "warning" | "error";

export type PropertyRowValuesStatus = "ok" | "snapshot_rotated" | "row_absent";

export type PropertyRudderAiErrorClass = "agent_error" | "runner_error" | "turn_timeout";

export type PropertyRudderAiErrorKind = "offline" | "interrupted" | "http_4xx" | "http_5xx" | "agent_error" | "unknown";

export type PropertyRudderAiFeedbackAction = "rated" | "changed" | "retracted";

export type PropertyRudderAiFeedbackRating = "up" | "down";

export type PropertyRudderAiPromptSource = "composer" | "starter_suggestion" | "follow_up_action" | "retry";

export type PropertyRudderAiTurnStatus = "done" | "error" | "stopped";

export type PropertyScheduleType = "basic" | "cron" | "manual";

export type PropertySectionName = "foundation" | "data_quality" | "activation";

export type PropertySignupMethod = "email_password" | "google" | "sso" | "invite";

export type PropertySignupSource = "organic" | "invite" | "databricks_partner" | "referral";

export type PropertySkipReason = "high_cardinality";

export type PropertySourceCategory = "event_stream" | "cloud_extract" | "warehouse_action" | "singer";

export type PropertyStepWhereFailed = "payment_method" | "3ds_authentication" | "charge_confirmation";

export type PropertySurface = "retl" | "audience" | "pastRun";

export type PropertySyncFrequency = "manual" | "hourly" | "daily" | "custom";

export type PropertySyncStatus = "success" | "failed" | "partial";

export type PropertySyncType = "full" | "incremental";

export type PropertyTemplateType = "custom" | "template";

export type PropertyTestResult = "success" | "error";

export type PropertyThreshold = 80 | 90 | 95;

export type PropertyTimeRange = "1h" | "6h" | "24h" | "7d" | "30d" | "custom";

export type PropertyTimeWindow = "2h" | "day" | "week" | "month";

export type PropertyTokenScope = "organization" | "workspace";

export type PropertyTrigger = "auto_signup" | "opt_in_free" | "admin_extension";

export type PropertyTriggerType = "manual" | "scheduled";

export type PropertyUiSurface = "runHistoryRow" | "artifactsPanel";

export type PropertyUiVersion = "v1" | "v2";

export type PropertyValidationStatus = "passed" | "failed" | "skipped";

export type PropertyVia = "tile" | "dropdown" | "search";

export type PropertyViolationType = "unplanned_event" | "missing_property" | "type_mismatch" | "unknown_property";

export type PropertyWarehouseType = "snowflake" | "redshift" | "databricks" | "bigquery";

export type PropertyWarningPhase = "early" | "mid" | "urgent";

export type PropertyWarningType = "badge_color_change" | "expiry_banner" | "expiry_modal" | "checklist_slot_nudge";

export type PropertyWorkspacePurpose = "production" | "development" | "staging";


// ===== Custom Types =====

export type CustomTypeBillingCycleType = "month" | "year";

export type CustomTypeEnvironmentType = "PRODUCTION" | "DEVELOPMENT";

export type CustomTypePlanNameType = "Free Tier" | "Starter" | "Pro" | "Growth" | "Enterprise" | "Open source plan";

export type CustomTypeRegionType = "US" | "EU" | "IN";

export type CustomTypeRoleType = "admin" | "member";

export type CustomTypeVolumeTierType = string;


// ===== Event Types =====

/** Associates user with their organization. Called on login, workspace switch, and first connection created. */
export interface GroupTraits {
    billingCycle?: CustomTypeBillingCycleType;
    environment: CustomTypeEnvironmentType;
    isTrial: boolean;
    orgConnectionCreated: boolean;
    orgCreatedAt: string;
    orgName: string;
    planName: CustomTypePlanNameType;
    region: CustomTypeRegionType;
    totalConnectionsCount: number;
    totalDestinationsCount: number;
    totalMembersCount: number;
    totalSourcesCount: number;
    totalWorkspacesCount: number;
}


/** Establishes user identity and traits. Called on every login, workspace switch, and onboarding completion. */
export interface IdentifyTraits {
    billingCycle?: CustomTypeBillingCycleType;
    company?: string;
    email: string;
    environment: CustomTypeEnvironmentType;
    gracePeriodEndDate?: string;
    isGracePeriod?: boolean;
    isInternal?: boolean;
    isTrial: boolean;
    onboardingQuestionsStatus?: PropertyOnboardingQuestionsStatus;
    organizationId: string;
    planName?: CustomTypePlanNameType;
    questionHowDidYouHear?: string;
    questionMigratingFrom?: string;
    questionProductInterest?: unknown[];
    region: CustomTypeRegionType;
    role: CustomTypeRoleType;
    trialEndDate?: string;
    trialStartDate?: string;
    userCompanyRole?: unknown[];
    userCreatedAt: string;
    userName: string;
    workspaceId: string;
}


/** Tracks page views on every client-side route change via React Router. Uses a route-to-metadata map to derive name and category. */
export interface PageProperties {
    pageCategory: PropertyPageCategory;
    pageName: string;
}


/** New organization record provisioned in the system (server-side) */
export interface AccountCreated {
    isTrial: boolean;
    organizationId: string;
    planName: CustomTypePlanNameType;
    region: CustomTypeRegionType;
    signupSource: PropertySignupSource;
}


/** User creates or modifies an alert rule */
export interface AlertConfigured {
    action: PropertyAction;
    alertName: string;
    resourceCategory: PropertyResourceCategory;
    resourceId: string;
    resourceType: string;
}


/** User enables or disables a specific alert */
export interface AlertToggled {
    alertName: string;
    channelType: PropertyChannelType;
    isEnabled: boolean;
    resourceId: string;
}


/** New audience saved (Data Graph Audiences or Cohort Audiences) */
export interface AudienceCreated {
    audienceId: string;
    audienceName: string;
    audienceType: PropertyAudienceType;
    dataGraphId: string;
    expressionComplexity?: number;
    profilesProjectId?: string;
    rootModel?: string;
}


/** User deletes an audience */
export interface AudienceDeleted {
    audienceId: string;
    dataGraphId: string;
}


/** User opens an audience detail page */
export interface AudienceDetailViewed {
    audienceId: string;
    dataGraphId: string;
    syncCount: number;
}


/** User modifies an audience expression in the builder */
export interface AudienceExpressionEdited {
    audienceId: string;
    audienceType: PropertyAudienceType;
    conditionCount: number;
    dataGraphId: string;
    usesAggregates: boolean;
    usesRelationships: boolean;
    usesTimeWindows: boolean;
}


/** User opens the audience list page for a Data Graph */
export interface AudienceListViewed {
    dataGraphId: string;
    totalAudiencesCount: number;
}


/** User triggers an audience preview */
export interface AudiencePreviewSubmitted {
    audienceId: string;
    dataGraphId: string;
}


/** User renames an audience */
export interface AudienceRenamed {
    audienceId: string;
    dataGraphId: string;
}


/** User committed an audience condition value on a value-suggestion-bearing string column; captures whether the value came from the suggested pick-list or was typed off-list (rudder-webapp) */
export interface AudienceSuggestionUsed {
    audienceId?: string;
    columnName: string;
    conditionOperator: PropertyConditionOperator;
    dataGraphId: string;
    suggestionsCount?: number;
    valueFromSuggestion: boolean;
}


/** Audience sync to a destination finishes (server-side) */
export interface AudienceSyncCompleted {
    audienceId: string;
    destinationId: string;
    destinationType: string;
    durationSeconds: number;
    organizationId: string;
    recordsSyncedCount: number;
    syncStatus: PropertySyncStatus;
    workspaceId: string;
}


/** User sets up a sync from an audience to a destination */
export interface AudienceSyncConfigured {
    audienceId: string;
    audienceType: PropertyAudienceType;
    dataGraphId: string;
    destinationId: string;
    destinationType: string;
    syncFrequency: PropertySyncFrequency;
    syncId: string;
}


/** User creates a sync from an audience to a destination */
export interface AudienceSyncCreated {
    audienceId: string;
    dataGraphId: string;
    destinationId: string;
    destinationType: string;
    syncId: string;
}


/** User deletes an audience sync */
export interface AudienceSyncDeleted {
    audienceId: string;
    syncId: string;
}


/** User opens an audience sync detail page */
export interface AudienceSyncDetailViewed {
    audienceId: string;
    destinationId: string;
    destinationType: string;
    syncId: string;
}


/** User edits the configuration of an audience sync */
export interface AudienceSyncEdited {
    audienceId: string;
    destinationId: string;
    destinationType: string;
    syncId: string;
}


/** RETL sync job starts for a Data Graph audience — paired with audienceSyncCompleted on finish (server-side, from config-backend) */
export interface AudienceSyncExecuted {
    audienceId: string;
    dataGraphId: string;
    destinationId: string;
    destinationType: string;
    organizationId: string;
    sourceId: string;
    sourceType: string;
    workspaceId: string;
}


/** User enables or disables an audience sync */
export interface AudienceSyncToggled {
    audienceId: string;
    syncId: string;
    toggleValue: boolean;
}


/** User manually starts a run of an audience sync, incremental or full (rudder-webapp) */
export interface AudienceSyncTriggered {
    audienceId: string;
    destinationId: string;
    destinationType: string;
    syncId: string;
    syncType: PropertySyncType;
}


/** User changes bot blocking mode at workspace or source level */
export interface BotBlockingConfigured {
    blockingMode: PropertyBlockingMode;
    isEnabled: boolean;
    scope: string;
    sourceId?: string;
}


/** User enables or disables AI bot detection */
export interface BotDetectionToggled {
    isEnabled: boolean;
    scope: string;
    sourceId?: string;
}


/** New event definition added to the data catalog */
export interface CatalogEventCreated {
    category?: string;
    eventName: string;
    eventType: PropertyEventType;
}


/** Event definition removed from the data catalog */
export interface CatalogEventDeleted {
    eventName: string;
    eventType: PropertyEventType;
}


/** New property definition added to the data catalog */
export interface CatalogPropertyCreated {
    propertyName: string;
    propertyType: PropertyPropertyType;
}


/** Property definition removed from the data catalog */
export interface CatalogPropertyDeleted {
    propertyName: string;
    propertyType: PropertyPropertyType;
}


/** User opened checkout but navigated away without completing payment */
export interface CheckoutAbandoned {
    abandonmentReason?: PropertyAbandonmentReason;
    lastStepReached: string;
    selectedBillingCycle: CustomTypeBillingCycleType;
    selectedVolumeTier?: CustomTypeVolumeTierType;
    timeInCheckoutSeconds: number;
}


/** Payment confirmed and subscription active (client + server-side) */
export interface CheckoutCompleted {
    amount: number;
    billingCycle: CustomTypeBillingCycleType;
    currency: PropertyCurrency;
    isFirstPaidPlan: boolean;
    organizationId: string;
    paymentMethodType?: PropertyPaymentMethodType;
    planName: CustomTypePlanNameType;
    previousPlan: string;
    referralSource: string;
    timeSinceSignupSeconds?: number;
    timeSinceTrialStartSeconds?: number;
    trialDaysUsed?: number;
    volumeTier: CustomTypeVolumeTierType;
}


/** Payment or checkout error including Stripe decline, 3DS failure, or network error */
export interface CheckoutError {
    errorCode?: string;
    errorType: PropertyErrorType;
    isRetry: boolean;
    retryCount: number;
    stepWhereFailed: PropertyStepWhereFailed;
}


/** Subscription drawer opens with payment form visible */
export interface CheckoutStarted {
    referralSource: string;
    selectedBillingCycle: CustomTypeBillingCycleType;
    selectedPlan?: string;
    selectedVolumeTier?: CustomTypeVolumeTierType;
}


/** User completes a step in the checkout flow */
export interface CheckoutStepCompleted {
    stepName: string;
    stepNumber: number;
    timeInStepSeconds: number;
    totalSteps: number;
}


/** A user clicks an interactive element. One generic event fired across the funnel; props describe what was clicked, where, and the object context. Replaces dozens of bespoke named click events. */
export interface Click {
    contextObjectId?: string;
    contextObjectType?: string;
    ctaName: string;
    elementText?: string;
    elementType?: string;
    entryPoint?: string;
    pageSection?: string;
    targetUrl?: string;
}


/** User re-upgrades to a paid plan and reactivates previously preserved configs (server-side) */
export interface ConfigReactivated {
    daysSinceDowngrade: number;
    newPlan: string;
    organizationId: string;
    previousTrialFeaturesUsed?: unknown[];
    reactivatedResources: unknown[];
}


/** A source is successfully linked to a destination — the core value event */
export interface ConnectionCreated {
    connectionMode?: PropertyConnectionMode;
    creationMethod?: string;
    destinationCategory?: PropertyDestinationCategory;
    destinationId: string;
    destinationType: string;
    isFirstConnection?: boolean;
    isFirstConnectionInOrg?: boolean;
    sourceCategory?: PropertySourceCategory;
    sourceId: string;
    sourceType?: string;
    totalConnectionsCount?: number;
    totalUniqueDestinationTypesCount?: number;
    totalUniqueSourceTypesCount?: number;
}


/** A source is unlinked from a destination */
export interface ConnectionRemoved {
    destinationCategory?: PropertyDestinationCategory;
    destinationId: string;
    destinationType: string;
    remainingConnectionsCount?: number;
    sourceCategory?: PropertySourceCategory;
    sourceId: string;
    sourceType: string;
}


/** An audience expression is hydrated to physical schema (server-side, from dataplane-gateway) */
export interface DataGraphAudienceHydrated {
    audienceId: string;
    dataGraphId: string;
    organizationId: string;
    workspaceId: string;
}


/** User saved column-metadata changes on a Data Graph model — display-name aliases, descriptions, PII masks, and value-suggestion toggles (rudder-webapp) */
export interface DataGraphColumnMetadataUpdated {
    aliasedCount?: number;
    columnsChangedCount: number;
    dataGraphId: string;
    describedCount?: number;
    modelId: string;
    piiMaskDisabledCount?: number;
    piiMaskEnabledCount?: number;
    suggestionsDisabledCount?: number;
    suggestionsEnabledCount?: number;
}


/** A high-cardinality string column's value-suggestions were skipped and the in-builder skip notice was shown (rudder-webapp) */
export interface DataGraphColumnSuggestionsSkipped {
    columnName: string;
    dataGraphId: string;
    skipReason: PropertySkipReason;
}


/** User creates a Data Graph from a warehouse account */
export interface DataGraphCreated {
    dataGraphId: string;
    warehouseType: PropertyWarehouseType;
}


/** User deletes a Data Graph */
export interface DataGraphDeleted {
    dataGraphId: string;
}


/** User creates a model (entity or event) in the Data Graph */
export interface DataGraphModelCreated {
    dataGraphId: string;
    modelId: string;
    modelType: PropertyModelType;
}


/** User deletes a Data Graph model */
export interface DataGraphModelDeleted {
    dataGraphId: string;
    modelId: string;
    modelType: PropertyModelType;
}


/** User updates configuration of a Data Graph model */
export interface DataGraphModelUpdated {
    dataGraphId: string;
    modelId: string;
    modelType: PropertyModelType;
}


/** User creates a relationship between models in the Data Graph */
export interface DataGraphRelationshipCreated {
    dataGraphId: string;
    relationshipId: string;
    relationshipType: PropertyRelationshipType;
    sourceModelId: string;
    targetModelId: string;
    totalRelationshipsCount: number;
}


/** User deletes a relationship in the Data Graph */
export interface DataGraphRelationshipDeleted {
    dataGraphId: string;
    relationshipId: string;
}


/** User navigates to the Data Graph page */
export interface DataGraphViewed {
    dataGraphId: string;
    modelsCount: number;
    relationshipsCount: number;
}


/** Destination successfully saved after setup */
export interface DestinationCreated {
    connectionMode: PropertyConnectionMode;
    destinationCategory: PropertyDestinationCategory;
    destinationId: string;
    destinationName: string;
    destinationType: string;
    isFirstDestination: boolean;
    totalDestinationsCount: number;
}


/** User confirms destination deletion */
export interface DestinationDeleted {
    connectedSourcesCount: number;
    destinationCategory: PropertyDestinationCategory;
    destinationId: string;
    destinationType: string;
    hadActiveConnections: boolean;
}


/** User disables a destination */
export interface DestinationDisabled {
    connectedSourcesCount: number;
    destinationCategory: PropertyDestinationCategory;
    destinationId: string;
    destinationType: string;
}


/** User re-enables a disabled destination */
export interface DestinationEnabled {
    destinationCategory: PropertyDestinationCategory;
    destinationId: string;
    destinationType: string;
}


/** User selects a destination type to begin creation */
export interface DestinationSetupStarted {
    destinationCategory: PropertyDestinationCategory;
    destinationType: string;
    entryPoint: string;
}


/** User completes a step in the destination creation flow */
export interface DestinationSetupStepCompleted {
    destinationCategory: PropertyDestinationCategory;
    destinationType: string;
    stepName: string;
    stepNumber: number;
    totalSteps: number;
}


/** User searches for an integration in the directory */
export interface DirectorySearched {
    resultSelected: boolean;
    resultsCount: number;
    searchQuery: string;
    tab: string;
}


/** User navigates to the integration directory */
export interface DirectoryViewed {
    subTab?: string;
    tab: string;
}


/** User adds an event to the block list */
export interface EventBlockingRuleCreated {
    blockedEventName: string;
    blockingLimit: number;
    totalBlockedEventsCount: number;
}


/** User removes an event from the block list */
export interface EventBlockingRuleRemoved {
    remainingBlockedEventsCount: number;
    unblockedEventName: string;
}


/** User enables or disables the event blocking feature globally */
export interface EventBlockingToggled {
    isEnabled: boolean;
    totalBlockedEventsCount: number;
}


/** User attempts to access a feature gated on their current plan */
export interface FeatureGateEncountered {
    currentPlan: string;
    entryPoint: string;
    featureName: PropertyFeatureName;
    requiredPlan: PropertyRequiredPlan;
}


/** A config form field fails validation or shows an error. Captures which field and the error type to find friction in source/destination setup. Never captures the field value. */
export interface FormFieldError {
    contextObjectId?: string;
    fieldLabel?: string;
    fieldName: string;
    fieldType?: string;
    formErrorType: string;
    formObjectSubType?: string;
    formObjectType: string;
    isRequiredField?: boolean;
}


/** A user engages with a config form field (fires on blur-after-change). Captures the field label/name and form context to locate setup drop-off. Never captures the field value. */
export interface FormFieldInteracted {
    contextObjectId?: string;
    fieldLabel?: string;
    fieldName: string;
    fieldType?: string;
    formObjectSubType?: string;
    formObjectType: string;
    isRequiredField?: boolean;
}


/** All getting started checklist items completed (activation proxy) */
export interface GettingStartedCompleted {
    activationSectionUnlocked: boolean;
    sectionsCompleted: unknown[];
    stepsSkippedCount: number;
    timeSinceFirstLoginSeconds: number;
    timeSinceSignupSeconds: number;
    totalConnectionsCount: number;
    totalDestinationsCount: number;
    totalSourcesCount: number;
    totalSteps: number;
}


/** User completes an individual item in the getting started checklist */
export interface GettingStartedStepCompleted {
    isSectionComplete: boolean;
    sectionName: PropertySectionName;
    sectionStepsCompleted: number;
    sectionTotalSteps: number;
    stepName: string;
    stepNumber: number;
    stepsRemaining: number;
    timeSinceSignupSeconds: number;
    totalSteps: number;
}


/** User navigates to the Health Dashboard */
export interface HealthDashboardViewed {
    tab: string;
    timeRange: PropertyTimeRange;
}


/** User clicks into a specific resource detail view from the Health Dashboard */
export interface HealthResourceInspected {
    destinationId?: string;
    resourceCategory: PropertyResourceCategory;
    resourceStatus: PropertyResourceStatus;
    sourceId?: string;
    trackingPlanId?: string;
}


/** User requests a new integration that does not exist */
export interface IntegrationRequested {
    integrationName: string;
    integrationType: PropertyIntegrationType;
}


/** User opens the live event stream for a source, destination, or transformation */
export interface LiveEventsViewed {
    resourceId: string;
    resourceIntegrationType: string;
    resourceType: string;
}


/** SQL model saved successfully */
export interface ModelCreated {
    isFirstModel: boolean;
    modelId: string;
    modelName: string;
    warehouseType: PropertyWarehouseType;
}


/** User confirms model deletion */
export interface ModelDeleted {
    hadActiveSyncs: boolean;
    modelId: string;
}


/** User completes a step in the post-signup account setup questionnaire */
export interface OnboardingStepCompleted {
    stepName: string;
    stepNumber: number;
    wasSkipped: boolean;
}


/** Monthly overage invoice generated for events exceeding the selected volume tier (server-side) */
export interface OverageInvoiceGenerated {
    actualEventVolume: number;
    billingCycle: CustomTypeBillingCycleType;
    consecutiveOverageMonths: number;
    cpmRate: number;
    organizationId: string;
    overageAmount: number;
    overageEvents: number;
    tierEventLimit: number;
    volumeTier: CustomTypeVolumeTierType;
}


/** A paid invoice payment failed via Stripe — the abandonment/retry signal (server-side) */
export interface PaymentFailed {
    amount: number;
    email: string;
    organizationId: string;
}


/** A paid invoice payment succeeded via Stripe (server-side) */
export interface PaymentSucceeded {
    amount: number;
    email: string;
    organizationId: string;
}


/** The very first successful event delivery to a destination via a connection (one-time milestone per connection) */
export interface PipelineFirstDeliveryCompleted {
    connectionMode: PropertyConnectionMode;
    deliveryLatencyMs: number;
    destinationCategory: PropertyDestinationCategory;
    destinationId: string;
    destinationType: string;
    isFirstDeliveryInWorkspace: boolean;
    organizationId: string;
    sourceId: string;
    sourceType: string;
    timeSinceConnectionCreatedSeconds: number;
    workspaceId: string;
}


/** The very first event ever received by a source in this workspace (one-time milestone per source) */
export interface PipelineFirstEventReceived {
    isFirstSourceEventInWorkspace: boolean;
    organizationId: string;
    sourceCategory: PropertySourceCategory;
    sourceId: string;
    sourceType: string;
    timeSinceSourceCreatedSeconds: number;
    workspaceId: string;
}


/** Credential/connection validation finished during source or destination setup (passed, failed, or skipped) — captures why setups are abandoned */
export interface PipelineValidationCompleted {
    destinationType?: string;
    errorMessage?: string;
    failedStep?: string;
    resourceType: string;
    sourceType?: string;
    stepsPassed?: number;
    totalSteps?: number;
    validationStatus: PropertyValidationStatus;
}


/** Organization plan is upgraded, downgraded, or trial status changes (server-side) */
export interface PlanChanged {
    actorUserId?: string;
    annualContractValue?: number;
    billingCycle?: CustomTypeBillingCycleType;
    changeType: PropertyChangeType;
    email?: string;
    newEventAllocation?: number;
    newPlan: string;
    organizationId: string;
    previousEventAllocation?: number;
    previousPlan: string;
    volumeTier?: CustomTypeVolumeTierType;
}


/** Usage reaches a warning threshold (80%, 90%, 95% of plan allocation) */
export interface PlanLimitApproached {
    currentUsage: number;
    limitType: PropertyLimitType;
    planLimit: number;
    threshold: PropertyThreshold;
    usagePercentage: number;
}


/** User hits a hard plan limit and action is blocked or degraded */
export interface PlanLimitReached {
    blockedAction: string;
    limitType: PropertyLimitType;
    planLimit: number;
}


/** User selects a specific volume tier and billing cycle in the subscription drawer */
export interface PlanSelected {
    annualPrice?: number;
    isTierChange: boolean;
    monthlyPrice: number;
    previousBillingCycle?: string;
    previousVolumeTier?: string;
    selectedBillingCycle: CustomTypeBillingCycleType;
    selectedPlan: string;
    selectedVolumeTier: CustomTypeVolumeTierType;
}


/** User navigates to the Plans page with 3-tier pricing view */
export interface PricingPageViewed {
    currentPlan: string;
    isTrial: boolean;
    referralSource: string;
    trialDaysRemaining?: number;
}


/** Download-all-artifacts request for a Profiles run resolved. Funnel completion for the untyped profilesAllArtifactsDownloaded start event (not yet cataloged) */
export interface ProfilesAllArtifactsDownloadCompleted {
    durationMs: number;
    errorMessage?: string;
    projectId: string;
    runId: string;
    success: boolean;
    uiSurface: PropertyUiSurface;
}


/** User views run artifacts and results for a Profiles project */
export interface ProfilesArtifactsViewed {
    projectId: string;
    runId: string;
    runStatus: string;
}


/** User successfully converts an existing IDE-managed Profiles project to a Git-managed one */
export interface ProfilesProjectConverted {
    gitProvider: PropertyGitProvider;
    projectId: string;
}


/** Profiles project successfully saved */
export interface ProfilesProjectCreated {
    creationFlow: PropertyCreationFlow;
    gitProvider?: PropertyGitProvider;
    projectId: string;
    projectName: string;
    scheduleType?: PropertyScheduleType;
    warehouseType: PropertyWarehouseType;
}


/** User picks a creation flow (IDE, Git import, or Copilot) on the new Profiles project setup screen — funnel start for project creation */
export interface ProfilesProjectCreationStarted {
    creationFlow: PropertyCreationFlow;
}


/** Profiles run finishes with success or failure (server-side) */
export interface ProfilesRunCompleted {
    durationSeconds: number;
    entitiesProcessedCount?: number;
    isFirstSuccessfulRun: boolean;
    organizationId: string;
    projectId: string;
    runId: string;
    runStatus: string;
    workspaceId: string;
}


/** User triggers a profiles project run */
export interface ProfilesRunStarted {
    projectId: string;
    triggerType: PropertyTriggerType;
}


/** User tries to create a resource but hits the plan count limit */
export interface ResourceLimitReached {
    currentCount: number;
    planLimit: number;
    resourceType: string;
}


/** User clicks the CTA to enable per-record error details for a Reverse ETL connection */
export interface RetlErrorDetailsEnableClicked {
    sourceId: string;
    syncId: string;
}


/** User opens the drill-in drawer for a single failed record */
export interface RetlFailedRecordOpened {
    errorCode?: string;
    rowValuesStatus: PropertyRowValuesStatus;
    runId: string;
    sourceId: string;
    syncId: string;
}


/** User filters the Failed records list by error code tile, dropdown, or search */
export interface RetlFailedRecordsFiltered {
    errorCode?: string;
    runId: string;
    sourceId: string;
    syncId: string;
    via: PropertyVia;
}


/** User views the Failed records panel for a Reverse ETL sync run */
export interface RetlFailedRecordsPanelViewed {
    distinctCodes: number;
    runId: string;
    sourceId: string;
    surface: PropertySurface;
    syncId: string;
    totalFailed: number;
}


/** Reverse ETL source configured with warehouse data exposed as event source */
export interface RetlSourceCreated {
    audienceId?: string;
    dataOrigin: PropertyDataOrigin;
    modelId?: string;
    sourceId: string;
    sourceType: string;
}


/** Reverse ETL sync job finishes (server-side) */
export interface RetlSyncCompleted {
    destinationId: string;
    destinationType: string;
    durationSeconds: number;
    organizationId: string;
    recordsSyncedCount: number;
    sourceId: string;
    syncStatus: PropertySyncStatus;
    triggerType: PropertyTriggerType;
    workspaceId: string;
}


/** User manually triggers a Reverse ETL sync */
export interface RetlSyncTriggered {
    destinationId: string;
    destinationType: string;
    sourceId: string;
}


/** User clicks through an answer card to the referenced resource or doc — the task-completion proxy for the assistant. Object context rides the common-interaction props (contextObjectType/Id, targetUrl). */
export interface RudderAiCardClicked {
    cardKind: string;
    contextObjectId?: string;
    contextObjectType?: string;
    conversationId?: string;
    targetUrl?: string;
    turnId?: string;
}


/** User deletes a conversation (after the confirm dialog). */
export interface RudderAiConversationDeleted {
    conversationId?: string;
}


/** User renames a conversation. Cataloged ahead of the UI (rename is deferred in the M3 switcher); carries no title text. */
export interface RudderAiConversationRenamed {
    conversationId: string;
}


/** User starts a new conversation from the sidebar. */
export interface RudderAiConversationStarted {
    conversationId?: string;
}


/** User switches to another conversation via the header switcher. */
export interface RudderAiConversationSwitched {
    conversationId?: string;
    fromConversationId?: string;
}


/** User rates a completed answer with thumbs up/down — or changes/retracts the rating (feedbackAction distinguishes). Rating only, no reasons or free text. These events are the source of truth for feedback analysis; ratings are also projected best-effort onto the turn's Langfuse trace as a user_feedback score, which may lag (a retraction leaves the score in place), so do not expect the two to reconcile exactly. The in-product quality signal. */
export interface RudderAiFeedbackSubmitted {
    conversationId: string;
    requestId?: string;
    rudderAiFeedbackAction: PropertyRudderAiFeedbackAction;
    rudderAiFeedbackRating: PropertyRudderAiFeedbackRating;
    turnId: string;
}


/** User sends a question to the assistant. Carries the prompt text (capped) and its full length; the server-side rudderAiWebTurnCompleted records the same prompt with the turn outcome. */
export interface RudderAiMessageSent {
    conversationId?: string;
    promptLength: number;
    promptText: string;
    rudderAiPromptSource: PropertyRudderAiPromptSource;
    suggestionId?: string;
    suggestionReason?: string;
}


/** A turn finished successfully from the user's point of view (client-side; the done frame arrived). */
export interface RudderAiTurnCompleted {
    conversationId?: string;
    durationMs: number;
    requestId?: string;
    steps: number;
    turnId?: string;
}


/** A turn failed from the user's point of view. errorKind mirrors the error UX differentiation (offline, interrupted, http_4xx, http_5xx, agent_error, unknown). */
export interface RudderAiTurnError {
    conversationId?: string;
    requestId?: string;
    rudderAiErrorKind: PropertyRudderAiErrorKind;
    turnId?: string;
}


/** User pressed Stop on a running turn. */
export interface RudderAiTurnStopped {
    conversationId?: string;
    requestId?: string;
    turnId?: string;
}


/** One event per web chat turn, emitted SERVER-SIDE from rudder-agent-platform — the webapp must never call this. The truthful turn count (immune to ad-blockers) carrying what only the server knows: status, durations, tool steps, card kinds, tokens, model, cost. Joined to client events via conversationId/turnId/requestId; the gap between this and rudderAiTurnCompleted counts is the client-event loss rate. */
export interface RudderAiWebTurnCompleted {
    cacheReadTokens?: number;
    cacheWriteTokens?: number;
    cardKinds?: string;
    conversationId: string;
    costUsd?: number;
    durationMs: number;
    inputTokens?: number;
    model?: string;
    organizationId: string;
    outputTokens?: number;
    promptLength: number;
    promptText: string;
    requestId: string;
    rudderAiErrorClass?: PropertyRudderAiErrorClass;
    rudderAiTurnStatus: PropertyRudderAiTurnStatus;
    sdkSessionResumed?: boolean;
    steps?: number;
    ttffMs?: number;
    turnId: string;
    workspaceId: string;
}


/** User generates a new service access token */
export interface ServiceTokenCreated {
    tokenScope: PropertyTokenScope;
    totalTokensCount: number;
    workspaceId?: string;
}


/** Source successfully saved after setup */
export interface SourceCreated {
    isFirstSource: boolean;
    sourceCategory: PropertySourceCategory;
    sourceId: string;
    sourceName: string;
    sourceType: string;
    totalSourcesCount: number;
}


/** User confirms source deletion */
export interface SourceDeleted {
    connectedDestinationsCount: number;
    hadActiveConnections: boolean;
    sourceCategory: PropertySourceCategory;
    sourceId: string;
    sourceType: string;
}


/** User toggles a source off */
export interface SourceDisabled {
    connectedDestinationsCount: number;
    sourceCategory: PropertySourceCategory;
    sourceId: string;
    sourceType: string;
}


/** User toggles a disabled source back on */
export interface SourceEnabled {
    sourceCategory: PropertySourceCategory;
    sourceId: string;
    sourceType: string;
}


/** User's search term applied on the source Events tab, filtering the event flow graph and the event details table together */
export interface SourceEventsSearchApplied {
    searchTermLength: number;
    sourceId: string;
    timeWindow: PropertyTimeWindow;
}


/** User cleared the source Events tab search, restoring the unfiltered graph and table */
export interface SourceEventsSearchCleared {
    sourceId: string;
    timeWindow: PropertyTimeWindow;
}


/** Elapsed time from a search term applying to the filtered event flow chart having rendered */
export interface SourceEventsSearchLatency {
    durationMs: number;
    timeWindow: PropertyTimeWindow;
}


/** User selects an integration from the directory to begin source creation */
export interface SourceSetupStarted {
    entryPoint: string;
    sourceCategory: PropertySourceCategory;
    sourceType: string;
}


/** User completes a step in the multi-step source creation flow */
export interface SourceSetupStepCompleted {
    sourceCategory: PropertySourceCategory;
    sourceType: string;
    stepName: string;
    stepNumber: number;
    totalSteps: number;
}


/** User confirms subscription cancellation, access continues through cycle end (server-side) */
export interface SubscriptionCancelled {
    billingCycle?: CustomTypeBillingCycleType;
    cancellationReason?: string;
    effectiveDate: string;
    monthsAsCustomer?: number;
    organizationId: string;
    peakEventVolume?: number;
    planName?: CustomTypePlanNameType;
    totalLifetimeRevenue?: number;
    volumeTier?: CustomTypeVolumeTierType;
}


/** Subscription auto-renews at period end (server-side) */
export interface SubscriptionRenewed {
    amount: number;
    billingCycle: CustomTypeBillingCycleType;
    monthsAsCustomer: number;
    organizationId: string;
    planName: CustomTypePlanNameType;
    renewalCount: number;
    volumeTier: CustomTypeVolumeTierType;
}


/** User manually retries a failed sync or delivery */
export interface SyncRetryTriggered {
    destinationId: string;
    destinationType: string;
    errorCategory?: string;
    resourceType: string;
    sourceId?: string;
}


/** User sends an invitation to a new team member */
export interface TeamMemberInvited {
    invitedEmailDomain: string;
    invitedRole: string;
    invitedToWorkspaceId?: string;
    teamLimit: number;
    totalMembersCount: number;
}


/** User changes another member's role */
export interface TeamMemberRoleChanged {
    newRole: string;
    previousRole: string;
    scope: string;
    targetUserId: string;
}


/** Tracking plan linked to a source for validation */
export interface TrackingPlanConnected {
    dropEventsEnabled: boolean;
    sourceId: string;
    sourceType: string;
    totalConnectedSourcesCount: number;
    trackingPlanId: string;
    trackingPlanName: string;
}


/** New tracking plan saved */
export interface TrackingPlanCreated {
    creationMethod: string;
    initialEventsCount: number;
    isFirstTrackingPlan: boolean;
    trackingPlanId: string;
    trackingPlanName: string;
}


/** Tracking plan unlinked from a source */
export interface TrackingPlanDisconnected {
    remainingConnectedSourcesCount: number;
    sourceId: string;
    trackingPlanId: string;
}


/** Events or properties modified in a tracking plan */
export interface TrackingPlanEdited {
    totalEventsCount: number;
    totalPropertiesCount: number;
    trackingPlanId: string;
    trackingPlanName: string;
}


/** An incoming event violates a tracking plan rule (server-side, sampled) */
export interface TrackingPlanViolationDetected {
    actionTaken: string;
    organizationId: string;
    sourceId: string;
    trackingPlanId: string;
    violatingEventName: string;
    violationType: PropertyViolationType;
    workspaceId: string;
}


/** Transformation linked to a destination */
export interface TransformationConnected {
    destinationId: string;
    destinationMode: PropertyDestinationMode;
    destinationType: string;
    language: PropertyLanguage;
    transformationId: string;
}


/** New transformation saved successfully */
export interface TransformationCreated {
    isFirstTransformation: boolean;
    language: PropertyLanguage;
    templateType: PropertyTemplateType;
    totalTransformationsCount: number;
    transformationId: string;
    uiVersion?: PropertyUiVersion;
}


/** User confirms transformation deletion */
export interface TransformationDeleted {
    connectedDestinationsCount: number;
    language: PropertyLanguage;
    transformationId: string;
    uiVersion?: PropertyUiVersion;
    wasConnected: boolean;
}


/** Transformation unlinked from a destination */
export interface TransformationDisconnected {
    destinationId: string;
    destinationType: string;
    transformationId: string;
}


/** Reusable transformation library saved */
export interface TransformationLibraryCreated {
    language?: PropertyLanguage;
    libraryId: string;
    uiVersion?: PropertyUiVersion;
}


/** User confirms transformation library deletion */
export interface TransformationLibraryDeleted {
    language?: PropertyLanguage;
    libraryId: string;
    uiVersion?: PropertyUiVersion;
}


/** User publishes a draft transformation library (V2 draft mode) */
export interface TransformationLibraryPublished {
    hasDescription: boolean;
    language?: PropertyLanguage;
    libraryId: string;
    uiVersion?: PropertyUiVersion;
}


/** User publishes a draft transformation (V2 draft mode) */
export interface TransformationPublished {
    hasDescription: boolean;
    language: PropertyLanguage;
    transformationId: string;
    uiVersion?: PropertyUiVersion;
    versionNumber?: number;
}


/** User runs test on a transformation */
export interface TransformationTested {
    language: PropertyLanguage;
    testResult: PropertyTestResult;
    transformationId: string;
    uiVersion?: PropertyUiVersion;
}


/** Trial reaches a successful terminal state / converts (server-side) */
export interface TrialCompleted {
    email: string;
    organizationId: string;
    trialType: string;
}


/** Grace period ends and features revert to Free tier limits (server-side) */
export interface TrialExpired {
    activationStatus: PropertyActivationStatus;
    configPreservedUntil?: string;
    configsPreserved: boolean;
    email: string;
    featuresUsed: unknown[];
    organizationId: string;
    outcome: PropertyOutcome;
    peakEventVolume?: number;
    teamSize: number;
    trialDurationDays: number;
}


/** Internal admin extends a trial (server-side) */
export interface TrialExtended {
    cumulativeEventCapReset: boolean;
    email: string;
    extendDays: number;
    extendedByUserId: string;
    newEndDate: string;
    organizationId: string;
    previousEndDate: string;
    reason: string;
}


/** Trial end date passes without conversion, user enters 7-day grace period (server-side) */
export interface TrialGracePeriodStarted {
    activationStatus?: PropertyActivationStatus;
    email: string;
    featuresUsed?: unknown[];
    gracePeriodEndDate: string;
    organizationId: string;
    trialEndDate: string;
}


/** User completes the Day 31 migration wizard selecting which resources to keep */
export interface TrialMigrationWizardCompleted {
    actionTaken: string;
    resourcesFrozen: Record<string, unknown>[];
    resourcesKept: Record<string, unknown>[];
    timeSinceTrialExpiredSeconds: number;
}


/** Trial provisioned for an organization (server-side) */
export interface TrialStarted {
    email: string;
    eventCap: number;
    organizationId: string;
    previousPlan: string;
    trialEndDate: string;
    trialStartDate: string;
    trialType: string;
    trigger: PropertyTrigger;
    workspaceId: string;
}


/** In-app trial expiry warning is shown to the user */
export interface TrialWarningShown {
    ctaClicked: boolean;
    ctaShown: string;
    daysRemaining: number;
    warningPhase: PropertyWarningPhase;
    warningType: PropertyWarningType;
}


/** User clicks any upgrade CTA */
export interface UpgradeCtaClicked {
    ctaLocation: PropertyCtaLocation;
    ctaText: string;
    destinationPage: PropertyDestinationPage;
    triggerContext?: string;
}


/** An upgrade CTA is rendered and visible to the user (once per location per session) */
export interface UpgradeCtaViewed {
    ctaLocation: PropertyCtaLocation;
    ctaText: string;
    triggerContext?: string;
}


/** User finishes or skips through the entire onboarding questionnaire */
export interface UserCompletedOnboarding {
    completionStatus: PropertyCompletionStatus;
    questionHowDidYouHear?: string;
    questionMigratingFrom?: string;
    questionProductInterest?: unknown[];
    scheduledCall: boolean;
    stepsCompletedCount: number;
    totalSteps: number;
    userCompanyRole?: unknown[];
}


/** Successful authentication via any method */
export interface UserLoggedIn {
    authMethod: PropertyAuthMethod;
    isMfa: boolean;
    loginCount: number;
}


/** New user record created via initial signup or invite acceptance (server-side) */
export interface UserSignedUp {
    emailDomain: string;
    invitedByUserId?: string;
    isBusinessEmail: boolean;
    isFirstUserInOrg: boolean;
    organizationId: string;
    signupMethod: PropertySignupMethod;
    userId: string;
    workspaceId?: string;
}


/** User creates a new workspace within their organization */
export interface WorkspaceCreated {
    totalWorkspacesCount: number;
    workspaceId: string;
    workspaceName: string;
    workspacePurpose?: PropertyWorkspacePurpose;
}


/** User changes workspace-level settings */
export interface WorkspaceSettingsUpdated {
    newValue?: string;
    settingChanged: string;
}


/** User switches active workspace */
export interface WorkspaceSwitched {
    fromWorkspaceId: string;
    toWorkspaceId: string;
}


// ===== RudderTyper =====

/**
 * Type-safe wrappers for RudderStack tracking based on your Tracking Plan.
 *
 * Tracking Plan: Webapp Tracking Plan
 * - ID: webapp
 * - Version: 0
 *
 * The constructor takes a resolver function that returns the current
 * RudderAnalytics instance. It is re-invoked on every call, so a lazily-loaded
 * SDK is always resolved fresh rather than captured once at construction.
 *
 * @example
 * ```ts
 * import { RudderAnalytics } from "@rudderstack/analytics-js";
 * import { RudderTyper } from "./RudderTyper";
 *
 * const analytics = new RudderAnalytics();
 * analytics.load("YOUR_WRITE_KEY", "YOUR_DATA_PLANE_URL");
 * const rudderTyper = new RudderTyper(() => analytics);
 * ```
 *
 * In a browser app that loads the SDK asynchronously, the standard RudderStack
 * snippet swaps `window.rudderanalytics` from the buffering preloader to the real
 * SDK once it loads. Because the resolver re-resolves on every call, events are
 * always sent through the current SDK — an eagerly captured instance would pin the
 * preloader and silently drop events fired after the SDK loads:
 *
 * ```ts
 * const rudderTyper = new RudderTyper(() => window.rudderanalytics);
 * ```
 */
export class RudderTyper {
    private readonly resolveAnalytics: () => RudderAnalytics;

    /**
     * @param resolveAnalytics - a function that returns the current RudderAnalytics
     * instance. Re-invoked on every call so a lazily-loaded SDK is resolved fresh
     * rather than captured once at construction.
     */
    constructor(resolveAnalytics: () => RudderAnalytics) {
        this.resolveAnalytics = resolveAnalytics;
    }

    private get analytics(): RudderAnalytics {
        return this.resolveAnalytics();
    }

    public group(
        groupId: string,
        traits?: GroupTraits,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    public group(
        traits?: GroupTraits,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    /**
     * Associates user with their organization. Called on login, workspace switch, and first connection created.
     */
    public group(
        groupIdOrTraits?: string | GroupTraits,
        traitsOrOptions?: GroupTraits | ApiOptions,
        optionsOrCallback?: ApiOptions | ApiCallback,
        callback?: ApiCallback,
    ): void {
        if (typeof groupIdOrTraits === "string") {
            this.analytics.group(
                groupIdOrTraits,
                (traitsOrOptions ?? {}) as unknown as SDKIdentifyTraits,
                this.withRudderTyperContext(optionsOrCallback as ApiOptions | undefined),
                callback,
            );
        } else {
            this.analytics.group(
                (groupIdOrTraits ?? {}) as unknown as SDKIdentifyTraits,
                this.withRudderTyperContext(traitsOrOptions as ApiOptions | undefined),
                optionsOrCallback as ApiCallback | undefined,
            );
        }
    }

    public identify(
        userId: string,
        traits?: IdentifyTraits,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    public identify(
        traits?: IdentifyTraits,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    /**
     * Establishes user identity and traits. Called on every login, workspace switch, and onboarding completion.
     */
    public identify(
        userIdOrTraits?: string | IdentifyTraits,
        traitsOrOptions?: IdentifyTraits | ApiOptions,
        optionsOrCallback?: ApiOptions | ApiCallback,
        callback?: ApiCallback,
    ): void {
        if (typeof userIdOrTraits === "string") {
            this.analytics.identify(
                userIdOrTraits,
                (traitsOrOptions ?? {}) as unknown as SDKIdentifyTraits,
                this.withRudderTyperContext(optionsOrCallback as ApiOptions | undefined),
                callback,
            );
        } else {
            this.analytics.identify(
                (userIdOrTraits ?? {}) as unknown as SDKIdentifyTraits,
                this.withRudderTyperContext(traitsOrOptions as ApiOptions | undefined),
                optionsOrCallback as ApiCallback | undefined,
            );
        }
    }

    public page(
        category: string,
        name: string,
        properties?: PageProperties,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    public page(
        name: string,
        properties?: PageProperties,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    public page(
        properties?: PageProperties,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void;
    /**
     * Tracks page views on every client-side route change via React Router. Uses a route-to-metadata map to derive name and category.
     */
    public page(
        arg0?: string | PageProperties,
        arg1?: string | PageProperties | ApiOptions,
        arg2?: PageProperties | ApiOptions | ApiCallback,
        arg3?: ApiOptions | ApiCallback,
        arg4?: ApiCallback,
    ): void {
        if (typeof arg0 === "string" && typeof arg1 === "string") {
            this.analytics.page(
                arg0,
                arg1,
                arg2 as unknown as SDKApiObject,
                this.withRudderTyperContext(arg3 as ApiOptions | undefined),
                arg4,
            );
        } else if (typeof arg0 === "string") {
            this.analytics.page(
                arg0,
                arg1 as unknown as SDKApiObject,
                this.withRudderTyperContext(arg2 as ApiOptions | undefined),
                arg3 as ApiCallback | undefined,
            );
        } else {
            this.analytics.page(
                arg0 as unknown as SDKApiObject,
                this.withRudderTyperContext(arg1 as ApiOptions | undefined),
                arg2 as ApiCallback | undefined,
            );
        }
    }

    /**
     * New organization record provisioned in the system (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAccountCreated(
        props: AccountCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "accountCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User creates or modifies an alert rule
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAlertConfigured(
        props: AlertConfigured,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "alertConfigured",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User enables or disables a specific alert
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAlertToggled(
        props: AlertToggled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "alertToggled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * New audience saved (Data Graph Audiences or Cohort Audiences)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceCreated(
        props: AudienceCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User deletes an audience
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceDeleted(
        props: AudienceDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opens an audience detail page
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceDetailViewed(
        props: AudienceDetailViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceDetailViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User modifies an audience expression in the builder
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceExpressionEdited(
        props: AudienceExpressionEdited,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceExpressionEdited",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opens the audience list page for a Data Graph
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceListViewed(
        props: AudienceListViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceListViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User triggers an audience preview
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudiencePreviewSubmitted(
        props: AudiencePreviewSubmitted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audiencePreviewSubmitted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User renames an audience
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceRenamed(
        props: AudienceRenamed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceRenamed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User committed an audience condition value on a value-suggestion-bearing string column; captures whether the value came from the suggested pick-list or was typed off-list (rudder-webapp)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSuggestionUsed(
        props: AudienceSuggestionUsed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSuggestionUsed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Audience sync to a destination finishes (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncCompleted(
        props: AudienceSyncCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User sets up a sync from an audience to a destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncConfigured(
        props: AudienceSyncConfigured,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncConfigured",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User creates a sync from an audience to a destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncCreated(
        props: AudienceSyncCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User deletes an audience sync
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncDeleted(
        props: AudienceSyncDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opens an audience sync detail page
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncDetailViewed(
        props: AudienceSyncDetailViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncDetailViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User edits the configuration of an audience sync
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncEdited(
        props: AudienceSyncEdited,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncEdited",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * RETL sync job starts for a Data Graph audience — paired with audienceSyncCompleted on finish (server-side, from config-backend)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncExecuted(
        props: AudienceSyncExecuted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncExecuted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User enables or disables an audience sync
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncToggled(
        props: AudienceSyncToggled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncToggled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User manually starts a run of an audience sync, incremental or full (rudder-webapp)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackAudienceSyncTriggered(
        props: AudienceSyncTriggered,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "audienceSyncTriggered",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User changes bot blocking mode at workspace or source level
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackBotBlockingConfigured(
        props: BotBlockingConfigured,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "botBlockingConfigured",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User enables or disables AI bot detection
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackBotDetectionToggled(
        props: BotDetectionToggled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "botDetectionToggled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * New event definition added to the data catalog
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCatalogEventCreated(
        props: CatalogEventCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "catalogEventCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Event definition removed from the data catalog
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCatalogEventDeleted(
        props: CatalogEventDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "catalogEventDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * New property definition added to the data catalog
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCatalogPropertyCreated(
        props: CatalogPropertyCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "catalogPropertyCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Property definition removed from the data catalog
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCatalogPropertyDeleted(
        props: CatalogPropertyDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "catalogPropertyDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opened checkout but navigated away without completing payment
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCheckoutAbandoned(
        props: CheckoutAbandoned,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "checkoutAbandoned",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Payment confirmed and subscription active (client + server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCheckoutCompleted(
        props: CheckoutCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "checkoutCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Payment or checkout error including Stripe decline, 3DS failure, or network error
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCheckoutError(
        props: CheckoutError,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "checkoutError",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Subscription drawer opens with payment form visible
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCheckoutStarted(
        props: CheckoutStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "checkoutStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User completes a step in the checkout flow
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackCheckoutStepCompleted(
        props: CheckoutStepCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "checkoutStepCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A user clicks an interactive element. One generic event fired across the funnel; props describe what was clicked, where, and the object context. Replaces dozens of bespoke named click events.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackClick(
        props: Click,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "click",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User re-upgrades to a paid plan and reactivates previously preserved configs (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackConfigReactivated(
        props: ConfigReactivated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "configReactivated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A source is successfully linked to a destination — the core value event
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackConnectionCreated(
        props: ConnectionCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "connectionCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A source is unlinked from a destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackConnectionRemoved(
        props: ConnectionRemoved,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "connectionRemoved",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * An audience expression is hydrated to physical schema (server-side, from dataplane-gateway)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphAudienceHydrated(
        props: DataGraphAudienceHydrated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphAudienceHydrated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User saved column-metadata changes on a Data Graph model — display-name aliases, descriptions, PII masks, and value-suggestion toggles (rudder-webapp)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphColumnMetadataUpdated(
        props: DataGraphColumnMetadataUpdated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphColumnMetadataUpdated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A high-cardinality string column's value-suggestions were skipped and the in-builder skip notice was shown (rudder-webapp)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphColumnSuggestionsSkipped(
        props: DataGraphColumnSuggestionsSkipped,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphColumnSuggestionsSkipped",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User creates a Data Graph from a warehouse account
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphCreated(
        props: DataGraphCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User deletes a Data Graph
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphDeleted(
        props: DataGraphDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User creates a model (entity or event) in the Data Graph
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphModelCreated(
        props: DataGraphModelCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphModelCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User deletes a Data Graph model
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphModelDeleted(
        props: DataGraphModelDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphModelDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User updates configuration of a Data Graph model
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphModelUpdated(
        props: DataGraphModelUpdated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphModelUpdated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User creates a relationship between models in the Data Graph
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphRelationshipCreated(
        props: DataGraphRelationshipCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphRelationshipCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User deletes a relationship in the Data Graph
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphRelationshipDeleted(
        props: DataGraphRelationshipDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphRelationshipDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User navigates to the Data Graph page
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDataGraphViewed(
        props: DataGraphViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "dataGraphViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Destination successfully saved after setup
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDestinationCreated(
        props: DestinationCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "destinationCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User confirms destination deletion
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDestinationDeleted(
        props: DestinationDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "destinationDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User disables a destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDestinationDisabled(
        props: DestinationDisabled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "destinationDisabled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User re-enables a disabled destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDestinationEnabled(
        props: DestinationEnabled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "destinationEnabled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User selects a destination type to begin creation
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDestinationSetupStarted(
        props: DestinationSetupStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "destinationSetupStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User completes a step in the destination creation flow
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDestinationSetupStepCompleted(
        props: DestinationSetupStepCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "destinationSetupStepCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User searches for an integration in the directory
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDirectorySearched(
        props: DirectorySearched,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "directorySearched",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User navigates to the integration directory
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackDirectoryViewed(
        props: DirectoryViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "directoryViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User adds an event to the block list
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackEventBlockingRuleCreated(
        props: EventBlockingRuleCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "eventBlockingRuleCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User removes an event from the block list
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackEventBlockingRuleRemoved(
        props: EventBlockingRuleRemoved,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "eventBlockingRuleRemoved",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User enables or disables the event blocking feature globally
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackEventBlockingToggled(
        props: EventBlockingToggled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "eventBlockingToggled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User attempts to access a feature gated on their current plan
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackFeatureGateEncountered(
        props: FeatureGateEncountered,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "featureGateEncountered",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A config form field fails validation or shows an error. Captures which field and the error type to find friction in source/destination setup. Never captures the field value.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackFormFieldError(
        props: FormFieldError,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "formFieldError",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A user engages with a config form field (fires on blur-after-change). Captures the field label/name and form context to locate setup drop-off. Never captures the field value.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackFormFieldInteracted(
        props: FormFieldInteracted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "formFieldInteracted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * All getting started checklist items completed (activation proxy)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackGettingStartedCompleted(
        props: GettingStartedCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "gettingStartedCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User completes an individual item in the getting started checklist
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackGettingStartedStepCompleted(
        props: GettingStartedStepCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "gettingStartedStepCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User navigates to the Health Dashboard
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackHealthDashboardViewed(
        props: HealthDashboardViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "healthDashboardViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User clicks into a specific resource detail view from the Health Dashboard
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackHealthResourceInspected(
        props: HealthResourceInspected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "healthResourceInspected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User requests a new integration that does not exist
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackIntegrationRequested(
        props: IntegrationRequested,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "integrationRequested",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opens the live event stream for a source, destination, or transformation
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackLiveEventsViewed(
        props: LiveEventsViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "liveEventsViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * SQL model saved successfully
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackModelCreated(
        props: ModelCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "modelCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User confirms model deletion
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackModelDeleted(
        props: ModelDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "modelDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User completes a step in the post-signup account setup questionnaire
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackOnboardingStepCompleted(
        props: OnboardingStepCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "onboardingStepCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Monthly overage invoice generated for events exceeding the selected volume tier (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackOverageInvoiceGenerated(
        props: OverageInvoiceGenerated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "overageInvoiceGenerated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A paid invoice payment failed via Stripe — the abandonment/retry signal (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPaymentFailed(
        props: PaymentFailed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "paymentFailed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A paid invoice payment succeeded via Stripe (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPaymentSucceeded(
        props: PaymentSucceeded,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "paymentSucceeded",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * The very first successful event delivery to a destination via a connection (one-time milestone per connection)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPipelineFirstDeliveryCompleted(
        props: PipelineFirstDeliveryCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "pipelineFirstDeliveryCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * The very first event ever received by a source in this workspace (one-time milestone per source)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPipelineFirstEventReceived(
        props: PipelineFirstEventReceived,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "pipelineFirstEventReceived",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Credential/connection validation finished during source or destination setup (passed, failed, or skipped) — captures why setups are abandoned
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPipelineValidationCompleted(
        props: PipelineValidationCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "pipelineValidationCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Organization plan is upgraded, downgraded, or trial status changes (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPlanChanged(
        props: PlanChanged,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "planChanged",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Usage reaches a warning threshold (80%, 90%, 95% of plan allocation)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPlanLimitApproached(
        props: PlanLimitApproached,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "planLimitApproached",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User hits a hard plan limit and action is blocked or degraded
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPlanLimitReached(
        props: PlanLimitReached,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "planLimitReached",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User selects a specific volume tier and billing cycle in the subscription drawer
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPlanSelected(
        props: PlanSelected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "planSelected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User navigates to the Plans page with 3-tier pricing view
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackPricingPageViewed(
        props: PricingPageViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "pricingPageViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Download-all-artifacts request for a Profiles run resolved. Funnel completion for the untyped profilesAllArtifactsDownloaded start event (not yet cataloged)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesAllArtifactsDownloadCompleted(
        props: ProfilesAllArtifactsDownloadCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesAllArtifactsDownloadCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User views run artifacts and results for a Profiles project
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesArtifactsViewed(
        props: ProfilesArtifactsViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesArtifactsViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User successfully converts an existing IDE-managed Profiles project to a Git-managed one
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesProjectConverted(
        props: ProfilesProjectConverted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesProjectConverted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Profiles project successfully saved
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesProjectCreated(
        props: ProfilesProjectCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesProjectCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User picks a creation flow (IDE, Git import, or Copilot) on the new Profiles project setup screen — funnel start for project creation
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesProjectCreationStarted(
        props: ProfilesProjectCreationStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesProjectCreationStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Profiles run finishes with success or failure (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesRunCompleted(
        props: ProfilesRunCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesRunCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User triggers a profiles project run
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackProfilesRunStarted(
        props: ProfilesRunStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "profilesRunStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User tries to create a resource but hits the plan count limit
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackResourceLimitReached(
        props: ResourceLimitReached,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "resourceLimitReached",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User clicks the CTA to enable per-record error details for a Reverse ETL connection
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlErrorDetailsEnableClicked(
        props: RetlErrorDetailsEnableClicked,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlErrorDetailsEnableClicked",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opens the drill-in drawer for a single failed record
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlFailedRecordOpened(
        props: RetlFailedRecordOpened,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlFailedRecordOpened",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User filters the Failed records list by error code tile, dropdown, or search
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlFailedRecordsFiltered(
        props: RetlFailedRecordsFiltered,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlFailedRecordsFiltered",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User views the Failed records panel for a Reverse ETL sync run
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlFailedRecordsPanelViewed(
        props: RetlFailedRecordsPanelViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlFailedRecordsPanelViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Reverse ETL source configured with warehouse data exposed as event source
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlSourceCreated(
        props: RetlSourceCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlSourceCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Reverse ETL sync job finishes (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlSyncCompleted(
        props: RetlSyncCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlSyncCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User manually triggers a Reverse ETL sync
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRetlSyncTriggered(
        props: RetlSyncTriggered,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "retlSyncTriggered",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User clicks through an answer card to the referenced resource or doc — the task-completion proxy for the assistant. Object context rides the common-interaction props (contextObjectType/Id, targetUrl).
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiCardClicked(
        props: RudderAiCardClicked,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiCardClicked",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User explicitly closes the chat sidebar (close button). Paired with chatOpened for dwell analysis. Not fired on page unload/navigation — those are unreliable, so absence of a close does not mean the chat stayed open.
     *
     * @param props - Additional properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiChatClosed(
        props?: Record<string, unknown>,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiChatClosed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User opens the Rudder AI chat sidebar. Fires only for enabled orgs — the sidebar cannot be opened when AI is disabled.
     *
     * @param props - Additional properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiChatOpened(
        props?: Record<string, unknown>,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiChatOpened",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User deletes a conversation (after the confirm dialog).
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiConversationDeleted(
        props: RudderAiConversationDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiConversationDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User renames a conversation. Cataloged ahead of the UI (rename is deferred in the M3 switcher); carries no title text.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiConversationRenamed(
        props: RudderAiConversationRenamed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiConversationRenamed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User starts a new conversation from the sidebar.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiConversationStarted(
        props: RudderAiConversationStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiConversationStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User switches to another conversation via the header switcher.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiConversationSwitched(
        props: RudderAiConversationSwitched,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiConversationSwitched",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User rates a completed answer with thumbs up/down — or changes/retracts the rating (feedbackAction distinguishes). Rating only, no reasons or free text. These events are the source of truth for feedback analysis; ratings are also projected best-effort onto the turn's Langfuse trace as a user_feedback score, which may lag (a retraction leaves the score in place), so do not expect the two to reconcile exactly. The in-product quality signal.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiFeedbackSubmitted(
        props: RudderAiFeedbackSubmitted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiFeedbackSubmitted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User sends a question to the assistant. Carries the prompt text (capped) and its full length; the server-side rudderAiWebTurnCompleted records the same prompt with the turn outcome.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiMessageSent(
        props: RudderAiMessageSent,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiMessageSent",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A turn finished successfully from the user's point of view (client-side; the done frame arrived).
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiTurnCompleted(
        props: RudderAiTurnCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiTurnCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * A turn failed from the user's point of view. errorKind mirrors the error UX differentiation (offline, interrupted, http_4xx, http_5xx, agent_error, unknown).
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiTurnError(
        props: RudderAiTurnError,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiTurnError",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User pressed Stop on a running turn.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiTurnStopped(
        props: RudderAiTurnStopped,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiTurnStopped",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * One event per web chat turn, emitted SERVER-SIDE from rudder-agent-platform — the webapp must never call this. The truthful turn count (immune to ad-blockers) carrying what only the server knows: status, durations, tool steps, card kinds, tokens, model, cost. Joined to client events via conversationId/turnId/requestId; the gap between this and rudderAiTurnCompleted counts is the client-event loss rate.
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackRudderAiWebTurnCompleted(
        props: RudderAiWebTurnCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "rudderAiWebTurnCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User generates a new service access token
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackServiceTokenCreated(
        props: ServiceTokenCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "serviceTokenCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Source successfully saved after setup
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceCreated(
        props: SourceCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User confirms source deletion
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceDeleted(
        props: SourceDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User toggles a source off
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceDisabled(
        props: SourceDisabled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceDisabled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User toggles a disabled source back on
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceEnabled(
        props: SourceEnabled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceEnabled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User's search term applied on the source Events tab, filtering the event flow graph and the event details table together
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceEventsSearchApplied(
        props: SourceEventsSearchApplied,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceEventsSearchApplied",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User cleared the source Events tab search, restoring the unfiltered graph and table
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceEventsSearchCleared(
        props: SourceEventsSearchCleared,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceEventsSearchCleared",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Elapsed time from a search term applying to the filtered event flow chart having rendered
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceEventsSearchLatency(
        props: SourceEventsSearchLatency,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceEventsSearchLatency",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User selects an integration from the directory to begin source creation
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceSetupStarted(
        props: SourceSetupStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceSetupStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User completes a step in the multi-step source creation flow
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSourceSetupStepCompleted(
        props: SourceSetupStepCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "sourceSetupStepCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User confirms subscription cancellation, access continues through cycle end (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSubscriptionCancelled(
        props: SubscriptionCancelled,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "subscriptionCancelled",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Subscription auto-renews at period end (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSubscriptionRenewed(
        props: SubscriptionRenewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "subscriptionRenewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User manually retries a failed sync or delivery
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackSyncRetryTriggered(
        props: SyncRetryTriggered,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "syncRetryTriggered",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User sends an invitation to a new team member
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTeamMemberInvited(
        props: TeamMemberInvited,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "teamMemberInvited",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User changes another member's role
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTeamMemberRoleChanged(
        props: TeamMemberRoleChanged,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "teamMemberRoleChanged",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Tracking plan linked to a source for validation
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrackingPlanConnected(
        props: TrackingPlanConnected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trackingPlanConnected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * New tracking plan saved
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrackingPlanCreated(
        props: TrackingPlanCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trackingPlanCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Tracking plan unlinked from a source
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrackingPlanDisconnected(
        props: TrackingPlanDisconnected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trackingPlanDisconnected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Events or properties modified in a tracking plan
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrackingPlanEdited(
        props: TrackingPlanEdited,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trackingPlanEdited",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * An incoming event violates a tracking plan rule (server-side, sampled)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrackingPlanViolationDetected(
        props: TrackingPlanViolationDetected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trackingPlanViolationDetected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Transformation linked to a destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationConnected(
        props: TransformationConnected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationConnected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * New transformation saved successfully
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationCreated(
        props: TransformationCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User confirms transformation deletion
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationDeleted(
        props: TransformationDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Transformation unlinked from a destination
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationDisconnected(
        props: TransformationDisconnected,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationDisconnected",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Reusable transformation library saved
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationLibraryCreated(
        props: TransformationLibraryCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationLibraryCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User confirms transformation library deletion
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationLibraryDeleted(
        props: TransformationLibraryDeleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationLibraryDeleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User publishes a draft transformation library (V2 draft mode)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationLibraryPublished(
        props: TransformationLibraryPublished,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationLibraryPublished",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User publishes a draft transformation (V2 draft mode)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationPublished(
        props: TransformationPublished,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationPublished",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User runs test on a transformation
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTransformationTested(
        props: TransformationTested,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "transformationTested",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Trial reaches a successful terminal state / converts (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialCompleted(
        props: TrialCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Grace period ends and features revert to Free tier limits (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialExpired(
        props: TrialExpired,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialExpired",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Internal admin extends a trial (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialExtended(
        props: TrialExtended,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialExtended",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Trial end date passes without conversion, user enters 7-day grace period (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialGracePeriodStarted(
        props: TrialGracePeriodStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialGracePeriodStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User completes the Day 31 migration wizard selecting which resources to keep
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialMigrationWizardCompleted(
        props: TrialMigrationWizardCompleted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialMigrationWizardCompleted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Trial provisioned for an organization (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialStarted(
        props: TrialStarted,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialStarted",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * In-app trial expiry warning is shown to the user
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackTrialWarningShown(
        props: TrialWarningShown,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "trialWarningShown",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User clicks any upgrade CTA
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackUpgradeCtaClicked(
        props: UpgradeCtaClicked,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "upgradeCtaClicked",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * An upgrade CTA is rendered and visible to the user (once per location per session)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackUpgradeCtaViewed(
        props: UpgradeCtaViewed,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "upgradeCtaViewed",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User finishes or skips through the entire onboarding questionnaire
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackUserCompletedOnboarding(
        props: UserCompletedOnboarding,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "userCompletedOnboarding",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * Successful authentication via any method
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackUserLoggedIn(
        props: UserLoggedIn,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "userLoggedIn",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * New user record created via initial signup or invite acceptance (server-side)
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackUserSignedUp(
        props: UserSignedUp,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "userSignedUp",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User creates a new workspace within their organization
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackWorkspaceCreated(
        props: WorkspaceCreated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "workspaceCreated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User changes workspace-level settings
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackWorkspaceSettingsUpdated(
        props: WorkspaceSettingsUpdated,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "workspaceSettingsUpdated",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    /**
     * User switches active workspace
     *
     * @param props - The properties to include with this event
     * @param options - Optional ApiOptions for additional event configuration
     * @param callback - Optional callback fired after the call is dispatched
     */
    public trackWorkspaceSwitched(
        props: WorkspaceSwitched,
        options?: ApiOptions,
        callback?: ApiCallback,
    ): void {
        this.analytics.track(
            "workspaceSwitched",
            props as unknown as SDKApiObject,
            this.withRudderTyperContext(options),
            callback,
        );
    }

    private withRudderTyperContext(options?: ApiOptions): ApiOptions {
        const rudderTyperContext: SDKApiObject = {
            ruddertyper: {
                "platform": "typescript",
                "rudderCLIVersion": "0.25.1",
                "trackingPlanId": "webapp",
                "trackingPlanVersion": 0,
            },
        };
        return {
            ...(options ?? {}),
            context: {
                ...((options?.context ?? {}) as SDKApiObject),
                ...rudderTyperContext,
            },
        };
    }
}
